export default function getAuthorStats(ctx) {
	return {
    prefix: 'author',
    widgets: [
      {
        code: 'income',
        name: ctx.$t('stats.income'),
        url: '/stats/get-income',
        color: "success",
        icon: 'CreditCardIcon',
        symbol: ' €',
        type: "widget"
      },
      {
        code: 'ordersCompletedCount',
        name: ctx.$t('stats.completeOrder'),
        url: '/stats/get-orders-completed-count',
        icon: 'FileTextIcon',
        color: "info",
        type: "widget"
      },
      {
        code: 'successRate',
        name: ctx.$t('stats.successOrder'),
        url: '/stats/get-success-rate',
        icon: 'ThumbsUpIcon',
        delimited: true,
        color: "primary",
        type: "widget"
      },

      {
        code: 'graphIncome',
        name: ctx.$t('stats.graphIncomeGlobal'),
        lineName: ctx.$t("stats.income"),
        url: '/stats/get-graph-income',
        type: 'chart',
      },
      {
        code: 'graphOrders',
        name: ctx.$t('stats.graphOrders'),
        url: '/stats/get-graph-orders',
        type: 'chart',
        multiple_series: true
      }
    ]
  }
}
